import React from 'react'
import EducationItem from '../container/EducationItem'
import Degree from '../container/Degree'
import Certificate from '../container/Certificate'

const Education = () => {
  return (
    <div>

       <EducationItem/>
       <Degree/>
       <Certificate/>
    </div>
  )
}

export default Education